import { render, staticRenderFns } from "./DietaryDiagnosticCreateForm.vue?vue&type=template&id=d8bccf28&scoped=true&"
import script from "./DietaryDiagnosticCreateForm.vue?vue&type=script&lang=js&"
export * from "./DietaryDiagnosticCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./DietaryDiagnosticCreateForm.vue?vue&type=style&index=0&id=d8bccf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bccf28",
  null
  
)

export default component.exports